import React, {useState, useEffect} from 'react'
import SideMenu from '../../components/ProfileSideMenu/SideMenu'
import FavouriteComponent from '../../components/Favourite-component/FavouriteComponent'
import Navbar from '../../components/nav/NavBar';
import Footer from '../../components/footer/Footer';
import Loading from '../../components/loading/Loading';

export default function Favourits() {
    const [loading, setLoading] = useState(false); // Added loading state
    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 1000); // Hide loading after 1 second
    }, []);
    return (
        <>
            <Navbar />
            <div className='favourit-page-holder'>
                <div className='side-menu-component-holder'>
                    <SideMenu />
                </div>
                <div className='favourite-component-holder'>
                    <div className='page-name-holder'>Favourites</div>
                    {loading && <div className='overlay'> <Loading /> </div>}
                    <FavouriteComponent />

                </div>
            </div>
            <Footer />
        </>

    )
}
